import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Icon from './Icon';

const nav: [string, string][] = [
  ['/publico', 'Início'], ['/publico/mapa', 'Mapa das Árvores'], ['/publico/inventario', 'Inventário'],
  ['/publico/vistoria', 'Solicitar Vistoria'], ['/publico/ocorrencias', 'Ocorrências'], ['/publico/campanhas', 'Campanhas'],
  ['/publico/parques', 'Parques'], ['/publico/dados-abertos', 'Dados Abertos'], ['/publico/transparencia', 'Transparência']
];

export default function PublicHeader() {
  // Abaixo de 1050 px a navegacao principal some; o botao de menu abre a mesma lista.
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  return (
    <header className="site-header">
      <div className="brand-pair">
        <img src="/assets/logo-prefeitura.webp" alt="Prefeitura de Goiânia" />
        <span className="brand-separator" />
        <img src="/assets/logo-amma.webp" alt="AMMA" />
      </div>
      <nav className="main-nav" aria-label="Navegação principal">
        {nav.map(([to,label]) => <NavLink key={to} to={to} end={to === '/publico'}>{label}</NavLink>)}
      </nav>
      <div className="header-actions">
        <button className="icon-button" aria-label="Buscar"><Icon name="search" size={20} /></button>
        <Link className="login-button" to="/login"><Icon name="user" size={18}/> Entrar</Link>
        <img className="floraiq-header-logo" src="/assets/logo-floraiq.png" alt="FloraIQ" />
        <button className="icon-button menu-toggle" aria-label={open ? 'Fechar menu' : 'Abrir menu'} aria-expanded={open} aria-controls="public-mobile-nav" onClick={() => setOpen(o => !o)}>
          <Icon name={open ? 'close' : 'menu'} size={22} />
        </button>
      </div>
      {open && (
        <nav id="public-mobile-nav" className="mobile-nav" aria-label="Navegação principal">
          {nav.map(([to,label]) => <NavLink key={to} to={to} end={to === '/publico'}>{label}</NavLink>)}
          <Link className="login-button" to="/login"><Icon name="user" size={18}/> Entrar</Link>
        </nav>
      )}
    </header>
  );
}
